import { DefaultState } from 'store/types';
import { ReservationProviderStatuses, OptionRequiredOptionalNotSupportedStatuses } from 'store/reducers/reservation-provider/types';

export const POST_RESERVATION_PROVIDER_REQUEST = 'POST_RESERVATION_PROVIDER_REQUEST';
export const POST_RESERVATION_PROVIDER_SUCCESS = 'POST_RESERVATION_PROVIDER_SUCCESS';
export const POST_RESERVATION_PROVIDER_FAILURE = 'POST_RESERVATION_PROVIDER_FAILURE';

export interface ReservationProviderFrequencyParams {
  days: string[];
  time: string;
}

export interface ReservationProviderForm {
  id?: string;
  name: string;
  email?: string;
  phoneNumber?: string;
  website?: string;
  status: ReservationProviderStatuses;
  requestNumberRequired?: OptionRequiredOptionalNotSupportedStatuses;
  lodgingPolicyId?: string;
  sendNotification?: boolean;
  notificationEmail?: string;
  labelColor: string;
}

export interface PostReservationProviderRow {
  id: string;
  reportType: string;
  requestedDates: string;
  recipientsEmails: string[];
  weekDays: string[];
  sendTime: string;
}

export interface PostReservationProviderData {
  rows: PostReservationProviderRow[];
  totalCount: number;
}

export type PostReservationProviderState = DefaultState & {
  contents?: PostReservationProviderData;
};

interface PostReservationProviderRequest {
  type: typeof POST_RESERVATION_PROVIDER_REQUEST;
}

interface PostReservationProviderSuccess {
  type: typeof POST_RESERVATION_PROVIDER_SUCCESS;
  contents: PostReservationProviderData;
}

interface PostReservationProviderFailure {
  type: typeof POST_RESERVATION_PROVIDER_FAILURE;
}

export type PostReservationProviderActionTypes = PostReservationProviderRequest | PostReservationProviderSuccess | PostReservationProviderFailure;
